export default function getAllQueryParams(urlPath) {
  const url = new URL(urlPath);
  const targetURL = url.search;
  const searchParams = new URLSearchParams(targetURL);
  const parameters = {};

  for (const searchParamKey of searchParams.keys()) {
    parameters[searchParamKey] = searchParams.get(searchParamKey);
  }

  return parameters;
}
